<template>
  <div class="GrowthArg">
    <div class="GrowthArg-text">Surplus available for ARG consumption</div>
    <!-- 设置 -->
    <div class="GrowthArg-setup">
      <div class="GrowthArg-setup-grArg">
        <img
          :src="
            require('@/assets/images/YuliApp/storageActivity/storageUpgrade/goods_icon_suipian@2x.png')
          "
        />
        <p class="GrowthArg-setup-grArg-text">{{ growthArg }}</p>
      </div>
      <div class="GrowthArg-setup-button" @click="handleShowGrowthConfig">
        <img
          :src="
            require('@/assets/images/YuliApp/storageActivity/storageUpgrade/button_setup@2x.png')
          "
        />
        <!-- 红点 -->
        <div class="unClaimed" v-show="red_show">
          <img
            :src="
              require('@/assets/images/YuliApp/storageActivity/storageUpgrade/gantanhao.png')
            "
          />
        </div>
      </div>
    </div>

    <!-- 分割线 -->
    <div class="GrowthArg-divide">
      <img
        :src="
          require('@/assets/images/YuliApp/storageActivity/storageUpgrade/com_dividing_star@2x.png')
        "
      />
    </div>

    <!-- 消耗记录 -->
    <div class="GrowthArg-consume">
      <div class="GrowthArg-consume-text">
        <p class="GrowthArg-consume-text-usage">Cumulative usage</p>
        <p class="GrowthArg-consume-text-number">
          {{ grArgUsage.replace("-", "") }}
        </p>
      </div>

      <div class="GrowthArg-consume-button" @click="handleShowConsumeList">
        <img
          :src="
            require('@/assets/images/YuliApp/storageActivity/storageUpgrade/button_consume@2x.png')
          "
        />
      </div>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed } from "vue";
export default {
  components: {},
  props: {
    growth_arg: {
      type: String,
      default: "",
    },
    gr_arg_usage: {
      type: String,
      default: "",
    },
    redPoint_show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    growth_arg: {
      handler(value) {
        this.growthArg = value;
      },
      immediate: true,
      deep: true,
    },
    gr_arg_usage: {
      handler(value) {
        this.grArgUsage = value;
      },
      immediate: true,
      deep: true,
    },
    redPoint_show: {
      handler(value) {
        this.red_show = value;
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const growthArg = ref(""); //成长基金
    const grArgUsage = ref(""); //已使用的成长基金
    const red_show = ref(true); //红点展示

    const handleShowGrowthConfig = () => {
      emit("showConfig", true);
    };
    const handleShowConsumeList = () => {
      emit("showList", true);
    };
    return {
      growthArg,
      grArgUsage,
      handleShowGrowthConfig,
      handleShowConsumeList,
      red_show,
    };
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}
.GrowthArg {
  flex-shrink: 0;
  margin: 10px auto 8px auto;
  box-sizing: border-box;
  width: 350px;
  height: 220px;
  background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/png_bg_list@2x.png");
  background-size: 100% 100%;

  padding: 50px 0 0 0;
  &-text {
    padding-left: 35px;
    height: 22px;
    opacity: 1;
    color: rgba(89,94,114,1);
    font-size: 15px;
    font-weight: 500;
    font-family: "PingFang SC";
    text-align: left;
    line-height: 22px;
  }
  &-setup {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 7.5px;
    padding: 0 30px;
    &-grArg {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding-left: 19px;
      width: 230px;
      height: 50px;
      background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/png_kuang@2x.png");
      background-size: 100% 100%;
      &-text {
        color: rgba(50, 57, 81, 1);
        font-size: 24px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: center;
        line-height: 50px;
        margin-left: 2px;
      }
      img {
        width: 40px;
        height: 40px;
      }
    }
    &-button {
      position: relative;
      width: 42px;
      height: 42px;
      img {
        width: 100%;
        height: 100%;
      }
      //未领取
      .unClaimed {
        position: absolute;
        top: -1px;
        right: 3px;
        width: 12.8px;
        height: 12.8px;
        background: rgba(222, 75, 75, 1);
        border-radius: 50%;
        img {
          position: absolute;
          left: 4.32px;
          bottom: 5.2px;
          width: 11.2px;
          height: 12.8px;
        }
      }
    }
  }

  &-divide {
    margin: 0 auto;
    position: relative;
    width: 317px;
    height: 8px;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  &-consume {
    margin-top: 4.5px;
    box-sizing: border-box;
    padding: 0 30px 0 35px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-text {
      font-family: "PingFang SC";
      text-align: left;
      line-height: 22px;
      font-weight: 500;
      &-usage {
        color: rgba(89, 94, 114, 1);
        font-size: 15px;
      }
      &-number {
        color: rgba(50, 57, 81, 1);
        font-size: 18px;
      }
    }
    &-button {
      width: 42px;
      height: 42px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
